








import Vue from 'vue'
import { versionName } from '@/conf/env'

export default Vue.extend({
  data() {
    return {
      debug: versionName,
    }
  },
  created() {
    document.title = '工出头-灵活用工开放平台'
  }
})
